import axios from 'axios'

import {
  REQUEST_TRANSLATION_TOOLBAR_LANGUAGES_URL,
  REQUEST_TRANSLATION_TOOLBAR_SUBSCRIPTION_KEY,
  REQUEST_TRANSLATION_TOOLBAR_TRANSLATE_URL,
} from './RequestTranslationToolbar.constants'
import { getRequestTranslationToolbarTraceId } from './RequestTranslationToolbar.utils'

export function getRequestTranslationToolbarLanguages({ locale, signal }) {
  return axios.get(REQUEST_TRANSLATION_TOOLBAR_LANGUAGES_URL, {
    headers: {
      'accept-language': locale,
    },
    params: {
      'api-version': '2.0',
      scope: 'translation',
    },
    signal,
  })
}

export function getRequestTranslationToolbarTranslatedText({
  from,
  signal,
  text,
  to,
}) {
  return axios({
    baseURL: REQUEST_TRANSLATION_TOOLBAR_TRANSLATE_URL,
    data: [{ text }],
    headers: {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': REQUEST_TRANSLATION_TOOLBAR_SUBSCRIPTION_KEY,
      'X-ClientTraceId': getRequestTranslationToolbarTraceId(),
    },
    method: 'post',
    params: {
      'api-version': '3.0',
      from,
      textType: 'html',
      to,
    },
    responseType: 'json',
    signal,
    url: '/translate',
  })
}
